(function () {
    $(window).on("load", initalURLString);
    function initalURLString() {
        var prepopulated = false;
        var urldecodedValue = "";

        var selectElms = document.querySelectorAll('select');
        if (selectElms.length > 0) {
            var selectArr = Array.from(selectElms);
            selectArr.forEach(function (selectValue) {
                var matchedData = selectValue.getAttribute('data-sc-field-name');
                if (matchedData == 'Primary_Product_of_Interest__c') {

                    if (window.location.href.indexOf('?') > -1) {
                        var urlValue = window.location.href.split("?");
                        if (urlValue.length > 1) {
                            var listUrlValue = urlValue[1];
                            if (listUrlValue !== '') {
                                var splitUr1Value = listUrlValue.split('=');
                                if (splitUr1Value.length > 1 && splitUr1Value[0] == "ppoi") {
                                    urldecodedValue = decodeURI(splitUr1Value[1]);

                                    var selectedMatch = selectValue;
                                    var selectedopt = selectedMatch.options;
                                    var selectedArr = Array.from(selectedopt);
                                    selectedArr.forEach(function (optval) {
                                        if (optval.value == urldecodedValue) {
                                            prepopulated = true;
                                        }
                                    });
                                    if (prepopulated) {
                                        selectedArr.forEach(function (optval) {
                                            if (optval.value == urldecodedValue) {
                                                $(selectedMatch).val(urldecodedValue).trigger("change");
                                            }
                                            else if (optval.value != urldecodedValue) {
                                                selectedMatch.removeChild(optval);
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                }

            });
        }
    }
}(window.jQuery));


(function ($) {
    $(document).ready(function () {
        $('.select-dropdown-link select').on('change', function () {
            var redirect_url = $(this).val();
            if ($(this).find('option:selected').attr('linktype') === 'external') {
                window.open(sanitizeHtmlStrings(redirect_url), '_blank');
            } else {
                document.location.href = window.encodeURI(sanitizeHtmlStrings(decodeURI(redirect_url)));
            }
        });
    });
}(window.jQuery));